import { Guid } from 'guid-typescript';

import { MemberIdentity } from './memberidentity';
import '../../extensions/array';
import { UserType } from '~/v2/data/schema/userType';

export class BrainnetPrincipal {
  claims: any;
  name = '';
  identifier = '';
  activeMember: MemberIdentity = new MemberIdentity();

  constructor(
    claims: any,
    public isAdmin?: boolean,
  ) {
    this.identifier = claims?.sub;
    this.name = claims?.name;
    this.claims = claims;
    this.activeMember.identifier = Guid.createEmpty();
  }

  displayName(): string {
    return this.name != null ? this.name : '~logged in person~';
  }

  getUserType(): UserType {
    return Number(this.activeMember?.userType);
  }

  getProfessionalId(): string | null {
    return this.activeMember?.professionalId;
  }

  setActiveMember(member: MemberIdentity): void {
    this.activeMember = member;
  }
}
